import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsClient, publicPage, safeUrl } from '../../lib/analytics';
export default function SiteAnalytics() {
  const { pathname } = useLocation();
  const lastPage = useRef(null);
  useEffect(() => {
    let active = true;
    if (!publicPage(window.location)) { lastPage.current = null; return; }
    const url = safeUrl(window.location.href);
    analyticsClient().then(client => {
      if (!active || !client || lastPage.current === url) return;
      lastPage.current = url;
      client.capture('$pageview', { $current_url: url, $pathname: window.location.pathname, $referrer: safeUrl(document.referrer), language: /^\/fa(?:\/|$)/.test(window.location.pathname) ? 'fa' : 'en' });
    });
    const contact = event => {
      const link = event.target.closest?.('a');
      const href = link?.getAttribute('href') || '';
      const method = href.startsWith('mailto:') ? 'email' : href.startsWith('tel:') ? 'phone' : /\/(?:(?:fa|en)\/)?contact-us(?:[?#]|$)/.test(href) ? 'contact-page' : null;
      if (method) analyticsClient().then(client => { if (active && client) client.capture('contact_click', { contact_method: method, $current_url: url }); });
    };
    document.addEventListener('click', contact);
    return () => { active = false; document.removeEventListener('click', contact); };
  }, [pathname]);
  return null;
}
